import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const ThreadsIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Threads</title>
      <path
        d="M27.566 19.2947C27.4209 19.2265 27.2733 19.161 27.1238 19.0982C26.8638 14.4047 24.2441 11.7179 19.8455 11.6902C19.8255 11.6902 19.8057 11.6902 19.7857 11.6902C17.1548 11.6902 14.9666 12.7897 13.62 14.7901L16.0391 16.4145C17.0453 14.9201 18.6243 14.6016 19.7871 14.6016C19.8005 14.6016 19.8139 14.6016 19.8274 14.6016C21.2758 14.6107 22.3686 15.0229 23.0758 15.8267C23.5907 16.4119 23.9349 17.2207 24.1053 18.2415C22.8212 18.0277 21.4324 17.9622 19.9481 18.0455C15.7662 18.2812 13.0777 20.6692 13.2582 23.9869C13.3498 25.6699 14.2062 27.1176 15.6696 28.0635C16.9068 28.8629 18.5005 29.2539 20.1566 29.1656C22.3437 29.0482 24.0595 28.2313 25.2563 26.7376C26.1654 25.6033 26.7403 24.1332 26.9941 22.281C28.0365 22.8968 28.8089 23.7073 29.2355 24.6813C29.961 26.3372 30.0033 29.0587 27.735 31.2772C25.7479 33.2207 23.3592 34.0615 19.7492 34.0876C15.7448 34.0586 12.7161 32.8012 10.7471 30.3507C8.90346 28.0567 7.9505 24.7423 7.91511 20.5C7.95077 16.2577 8.90346 12.9433 10.7474 10.6485C12.7164 8.19798 15.7448 6.94063 19.7495 6.91162C23.783 6.94089 26.8643 8.20416 28.9088 10.6668C29.9111 11.8742 30.6671 13.3928 31.1653 15.1634L34 14.423C33.396 12.2437 32.4457 10.3657 31.1526 8.80812C28.5316 5.65105 24.6984 4.03357 19.7594 4H19.7396C14.8105 4.0333 11.0203 5.65722 8.47389 8.82612C6.20807 11.6462 5.03923 15.57 5 20.4885V20.5V20.5115C5.03923 25.43 6.20807 29.3538 8.47389 32.1739C11.0203 35.3428 14.8105 36.9667 19.7396 37H19.7594C24.1415 36.9702 27.2303 35.8471 29.775 33.3582C33.1044 30.102 33.004 26.0206 31.9067 23.515C31.1192 21.7181 29.6184 20.2588 27.566 19.2947ZM19.9999 26.2591C18.167 26.36 16.263 25.5547 16.1689 23.8295C16.0992 22.5504 17.0988 21.123 20.1124 20.953C20.4575 20.9334 20.7963 20.924 21.129 20.924C22.2235 20.924 23.2478 21.0282 24.1788 21.2275C23.8313 25.4733 21.7945 26.1627 19.9999 26.2591Z"
        fill={fill}
      />
    </svg>
  );
};

export default ThreadsIcon;
